import React from "react";
import { useSelector } from 'react-redux'
import {
    Button,
    DataTable, Table, TableBody, TableCell, TableContainer,
    TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
    TableToolbarSearch
} from '@carbon/react';
import { Filter } from '@carbon/icons-react';
import { useSorting } from "../../../modules/hooks/sorting";

const TransferToB57Table = _ => {
    const { table } = useSelector(state => state.ToB57);

    const headerData = [
        {
            header: 'Origen - Destino',
            key: 'origin',
        },
        {
            header: 'Tiempo de Traslado Promedio Jornada',
            key: 'time_diff_mean',
            sortDirection: "DESC",
            isDefaultSortable: true
        },
        {
            header: 'Mejor Tiempo de Traslado Jornada',
            key: 'time_diff_min',
            sortDirection: "DESC",
        }
    ];
    const { rows, headers } = useSorting(table, headerData);

    const Default = () => (
        <DataTable rows={rows} headers={headers} width="100%">
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps,
                getTableContainerProps,
                onInputChange,
                sortBy,
            }) => (
                <TableContainer {...getTableContainerProps()}>
                    <TableToolbar>
                        <TableToolbarContent>
                            {/* pass in `onInputChange` change here to make filtering work */}
                            <TableToolbarSearch onChange={onInputChange} />
                        </TableToolbarContent>
                    </TableToolbar>
                    <Table {...getTableProps()} aria-label="sample table">
                        <TableHead>
                            <TableRow>
                                {headers.map((header, i) => {
                                    const { key: _unusedKey, ...headerProps } = getHeaderProps({
                                        header,
                                        isSortable:
                                            (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                                        onClick: (_, sortState) => sortBy(sortState.sortHeaderKey),
                                    });

                                    return (
                                        <TableHeader
                                            key={i}
                                            sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                                            {...headerProps}
                                        >
                                            {header.header}
                                        </TableHeader>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => {
                                const { key: _unusedKey, ...rowProps } = getRowProps({ row });

                                return (
                                    <React.Fragment key={row.id}>
                                        <TableRow {...rowProps}>
                                            {row.cells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.value}</TableCell>
                                            ))}
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </DataTable>
    );

    return (
        <Default />
    )
}

export default TransferToB57Table;